export default "__VITE_ASSET__mqldC8Xr__"